module.exports = __webpack_public_path__ + "media/images/area/tokyo_hero_img_sp-20e24dd8d28e734a7764947a2953aa13.jpg";